import produce from "immer";
import {ACTION_TYPE} from "utils/constants";

const initialState = {
  disturbMode: false,
};

const voiceChat = (state = initialState, action) => {
  const {type} = action;

  switch (type) {
    case ACTION_TYPE.SET_DISTURB_MODE:
      return produce(state, draft => {
        draft.disturbMode = !state.disturbMode;
      });
    default:
      return state;
  }
};

export default voiceChat;
